// Document-level delegation: any [data-am-product-trigger] opens its referenced
// <dialog data-am-product-overlay> via showModal(); the close button inside
// closes it. ESC + focus restore are handled natively by <dialog>.
(function () {
  if (window.__amProductOverlayBound) return;
  window.__amProductOverlayBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-am-product-trigger]');
    if (trigger) {
      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (!dialog.open) {
        dialog.showModal();
        const closeBtn = dialog.querySelector('[data-am-product-overlay-close]');
        closeBtn?.focus({ preventScroll: true });
      }
      return;
    }

    const closeBtn = event.target.closest('[data-am-product-overlay-close]');
    if (closeBtn) {
      closeBtn.closest('dialog')?.close();
    }
  });
})();
